import SidebarBookingsSummaryAcceptController from 'uplisting-frontend/pods/-sidebar/bookings/summary/accept/controller';

export default class ProtectionOverviewBookingsSummaryAcceptController extends SidebarBookingsSummaryAcceptController {}
